import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1332ac4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contents" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title contents-title" }, "著者情報", -1))
const _hoisted_3 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmInput = _resolveComponent("ConfirmInput")!
  const _component_FormInput = _resolveComponent("FormInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("tbody", null, [
          _createVNode(_component_ConfirmInput, {
            name: '著者ID',
            value: _ctx.state.authorId,
            class: _normalizeClass('authorId')
          }, null, 8, ["value"]),
          _createVNode(_component_ConfirmInput, {
            name: '著者名',
            value: _ctx.state.authorName,
            class: _normalizeClass('authorName')
          }, null, 8, ["value"]),
          _createVNode(_component_FormInput, {
            modelValue: _ctx.state.authorInfo,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.authorInfo) = $event)),
            name: '著者の情報',
            description: '例：没年、連絡先など',
            required: false,
            id: 'authorInfo',
            textarea: true
          }, null, 8, ["modelValue"]),
          _createVNode(_component_FormInput, {
            modelValue: _ctx.state.infoSource,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.infoSource) = $event)),
            name: '情報源',
            description: '例：情報源となった書籍やウェブサイトのURLなど',
            required: false,
            id: 'infoSource',
            textarea: true
          }, null, 8, ["modelValue"])
        ])
      ])
    ])
  ]))
}